(function(){
  'use strict';
  const clamp=(v,min=0,max=1)=>Math.min(max,Math.max(min,v));

  function initHeader(root=document){
    root.querySelectorAll('.ma929-header-section').forEach(section=>{
      if(section.dataset.ma929Ready==='true') return;
      section.dataset.ma929Ready='true';
      const sticky=section.dataset.sticky==='true';
      const overlay=section.classList.contains('ma929-header--overlay');
      const searchBtn=section.querySelector('[data-ma929-search-toggle]');
      const searchPanel=section.querySelector('.ma929-search-panel');
      const menuBtn=section.querySelector('[data-ma929-menu-open]');
      const drawer=section.querySelector('.ma929-mobile-drawer');
      const closeBtn=section.querySelector('[data-ma929-menu-close]');
      const update=()=>{
        if(!sticky) return;
        const threshold=overlay?55:10;
        section.classList.toggle('is-sticky',window.scrollY>threshold);
      };
      window.addEventListener('scroll',update,{passive:true});update();
      const openSearch=()=>{
        section.classList.add('mobile-search-open');
        searchPanel?.classList.add('is-open');
        requestAnimationFrame(()=>searchPanel?.querySelector('input')?.focus());
      };
      const closeSearch=()=>{
        searchPanel?.classList.remove('is-open');
        section.classList.remove('mobile-search-open');
      };
      searchBtn?.addEventListener('click',e=>{
        e.preventDefault();
        if(searchPanel?.classList.contains('is-open')) closeSearch(); else openSearch();
      });
      document.addEventListener('pointerdown',e=>{
        if(!searchPanel?.classList.contains('is-open')) return;
        if(searchPanel.contains(e.target) || searchBtn?.contains(e.target) || e.target.closest('[data-open-search-popup]')) return;
        closeSearch();
      });
      menuBtn?.addEventListener('click',()=>{section.classList.add('menu-open');drawer?.classList.add('is-open');document.documentElement.classList.add('prevent-scroll');});
      closeBtn?.addEventListener('click',()=>{section.classList.remove('menu-open');drawer?.classList.remove('is-open');document.documentElement.classList.remove('prevent-scroll');});
      document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeSearch();section.classList.remove('menu-open');drawer?.classList.remove('is-open');document.documentElement.classList.remove('prevent-scroll');}});

      // Bridge the legacy mobile sticky-bar search icon to the MA929 search panel.
      if(!document.documentElement.dataset.ma929StickySearchReady){
        document.documentElement.dataset.ma929StickySearchReady='true';
        document.addEventListener('click',e=>{
          const stickySearch=e.target.closest('[data-open-search-popup]');
          if(!stickySearch) return;
          const currentSection=document.querySelector('.ma929-header-section');
          const currentPanel=currentSection?.querySelector('.ma929-search-panel');
          if(!currentSection || !currentPanel) return;
          e.preventDefault();
          e.stopPropagation();
          currentSection.classList.add('mobile-search-open');
          currentPanel.classList.add('is-open');
          requestAnimationFrame(()=>currentPanel.querySelector('input')?.focus());
        },true);
      }
    });
  }

  let ticking=false;
  function updateScrollEffects(){
    ticking=false;
    const vh=window.innerHeight||1;
    document.querySelectorAll('[data-ma929-parallax="true"]').forEach(section=>{
      const media=section.querySelector('.ma929-media-layer');
      if(!media) return;
      const rect=section.getBoundingClientRect();
      let progress;
      if(section.classList.contains('ma929-hero')) progress=clamp((-rect.top)/(rect.height||1));
      else progress=clamp((vh-rect.top)/(vh+(rect.height||1)));

      // The approved preview uses CSS background-attachment:fixed for the first hero
      // and MA929 Essentials. Do not apply JS movement to those two sections.
      if(section.classList.contains('ma929-hero') || section.classList.contains('ma929-banner--essentials')){
        media.style.removeProperty('transform');
        media.style.removeProperty('--ma929-parallax-y');
        media.style.removeProperty('--ma929-parallax-shift');
      }else{
        if(window.innerWidth <= 900){ media.style.removeProperty('--ma929-parallax-y'); return; }
        const y=30+(progress*40);
        media.style.setProperty('--ma929-parallax-y',`${y.toFixed(2)}%`);
      }
    });
    document.querySelectorAll('.ma929-reveal-heading').forEach(heading=>{
      const section=heading.closest('.ma929-banner');
      if(!section) return;
      const rect=section.getBoundingClientRect();
      const revealStart=vh*.35;
      const progress=clamp((revealStart-rect.top)/revealStart);
      heading.style.setProperty('--ma929-fill',`${(progress*100).toFixed(1)}%`);
    });
  }
  function queueEffects(){if(ticking)return;ticking=true;requestAnimationFrame(updateScrollEffects)}

  function initLook(root=document){
    root.querySelectorAll('.ma929-look').forEach(section=>{
      if(section.dataset.ma929LookReady==='true') return;
      section.dataset.ma929LookReady='true';
      section.addEventListener('click',e=>{
        const pin=e.target.closest('.ma929-pin');
        if(pin){
          e.preventDefault();e.stopPropagation();
          const card=section.querySelector(`#${CSS.escape(pin.dataset.card)}`);
          section.querySelectorAll('.ma929-pin-card').forEach(x=>x.classList.remove('is-open'));
          section.querySelectorAll('.ma929-pin').forEach(x=>x.classList.remove('is-active'));
          card?.classList.add('is-open');pin.classList.add('is-active');return;
        }
        if(!e.target.closest('.ma929-pin-card')){
          section.querySelectorAll('.ma929-pin-card').forEach(x=>x.classList.remove('is-open'));
          section.querySelectorAll('.ma929-pin').forEach(x=>x.classList.remove('is-active'));
        }
      });
      section.querySelectorAll('.ma929-pin').forEach(pin=>{
        pin.addEventListener('mouseenter',()=>{
          if(window.matchMedia('(hover:hover)').matches) pin.click();
        });
      });
    });
  }

  async function addVariant(variantId,button){
    if(!variantId) return;
    const original=button?.textContent;
    if(button){button.disabled=true;button.textContent='Adding…';}
    try{
      const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})});
      if(!res.ok) throw new Error(await res.text());
      if(window.Shopify?.onCartUpdate) await window.Shopify.onCartUpdate(null,true);
      else window.location.href='/cart';
    }catch(err){console.error('MA929 add to cart failed',err);if(button)button.textContent='Unavailable';setTimeout(()=>{if(button){button.textContent=original;button.disabled=false;}},1800);return;}
    if(button){button.textContent='Added';setTimeout(()=>{button.textContent=original;button.disabled=false;},900);}
  }

  document.addEventListener('click',e=>{
    const quick=e.target.closest('[data-ma929-quick-add]');
    if(quick){e.preventDefault();e.stopPropagation();addVariant(quick.dataset.variantId,quick);return;}
    const upsell=e.target.closest('[data-ma929-upsell-add]');
    if(upsell){e.preventDefault();addVariant(upsell.dataset.variantId,upsell);}
  });

  function initCollectionColorFilter(root=document){
    const controls=[...root.querySelectorAll('[data-ma929-collection-color]')];
    if(!controls.length) return;
    const section=controls[0].closest('[data-section-type="collection-template"]') || document;
    if(section.dataset.ma929ColorFilterReady==='true') return;
    section.dataset.ma929ColorFilterReady='true';

    const getControls=()=>[...section.querySelectorAll('[data-ma929-collection-color]')];
    const getCards=()=>[...section.querySelectorAll('.sf__col-item[data-ma929-product-colors]')];
    const empty=section.querySelector('[data-ma929-client-color-empty]');
    let active=(new URL(window.location.href)).searchParams.get('ma929_color') || '';

    const apply=(updateUrl=true)=>{
      let visible=0;
      getCards().forEach(card=>{
        const colors=card.dataset.ma929ProductColors || '|';
        const match=!active || colors.includes(`|${active}|`);
        card.hidden=!match;
        if(match) visible++;
      });
      getControls().forEach(control=>{
        const selected=!!active && control.dataset.ma929CollectionColor===active;
        control.classList.toggle('is-active',selected);
        control.setAttribute('aria-pressed',selected?'true':'false');
      });
      empty?.classList.toggle('is-visible',!!active && visible===0);
      if(updateUrl){
        const url=new URL(window.location.href);
        if(active) url.searchParams.set('ma929_color',active); else url.searchParams.delete('ma929_color');
        history.replaceState({},'',url.toString());
      }
    };

    section.addEventListener('click',e=>{
      const control=e.target.closest('[data-ma929-collection-color]');
      if(!control || !section.contains(control)) return;
      e.preventDefault();
      const requested=control.dataset.ma929CollectionColor || '';
      active=active===requested?'':requested;
      apply(true);
    });

    const listing=section.querySelector('[data-product-container]');
    if(listing){
      new MutationObserver(()=>{ if(active) apply(false); }).observe(listing,{childList:true,subtree:true});
    }
    apply(false);
  }

  function init(){initHeader();initLook();initCollectionColorFilter();updateScrollEffects();}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  window.addEventListener('scroll',queueEffects,{passive:true});
  window.addEventListener('resize',queueEffects);
  document.addEventListener('shopify:section:load',e=>{initHeader(e.target);initLook(e.target);initCollectionColorFilter(e.target);updateScrollEffects();});
})();
